import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { CoreConfig } from './../../../CoreConfig';
import { createTextView } from './AnimatedTextView';
export const SmallView = createTextView({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.small,
    style(theme) {
        var _a;
        return {
            container: {
                fontSize: 14,
                lineHeight: 18,
                color: ((_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.text_color) || '#394E66',
                fontWeight: 'normal'
            }
        };
    }
});
